export enum WorkflowEditTypes {
  EditInput = "EditInput",
  EditOutput = "EditOutput",
  EditProcess = "EditProcess",
  EditModule = "EditModule",
  EditDisplayName = "EditDisplayName",
  EditModel = "EditModel",
  EditSkill = "EditSkill",
}

export enum PipelineOperations {
  Save = "save",
  Revise = "revise",
  Delete = "delete",
}

export enum HandleTypes {
  Source = "source",
  Target = "target",
}

export enum EditProcessGroupTypes {
  MenuGroup = "MenuGroup",
  Parameters = "Parameters",
}

export enum EditProcessGroupOptions {
  CreateMenuGroup = "CreateMenuGroup",
  EditMenuGroup = "EditMenuGroup",
  DeleteMenuGroup = "DeleteMenuGroup",
  CreateParameter = "CreateParameter",
  EditParameter = "EditParameter",
  DeleteParameter = "DeleterParemeter",
}

export enum QualifierOptionsEnum {
  File = "file",
  Set = "set",
  Val = "val",
  Each = "each",
  Env = "env",
}

export const OperatorTypes: string[] = [
  "buffer",
  "choice",
  "close",
  "collate",
  "collect",
  "collectFile",
  "combine",
  "concat",
  "count",
  "countBy",
  "cross",
  "distinct",
  "dump",
  "filter",
  "first",
  "flatMap",
  "flatten",
  "groupBy",
  "groupTuple",
  "ifEmpty",
  "into",
  "join",
  "last",
  "map",
  "max",
  "merge",
  "min",
  "mix",
  "mode flatten",
  "phase",
  "print",
  "println",
  "randomSample",
  "reduce",
  "route",
  "separate",
  "set",
  "subscribe",
  "splitCsv",
  "splitFasta",
  "splitFastq",
  "splitText",
  "spread",
  "sum",
  "take",
  "tap",
  "toInteger",
  "toList",
  "toSortedList",
  "transpose",
  "unique",
  "view",
];

export const hydratedInput = {
  defVal: "",
  dropDown: "",
  showSett: "",
  inDescOpt: "",
  inLabelOpt: "",
};

export const hydratedOutput = {
  label: "",
  pubWeb: "",
  pubWebApp: {
    app: [],
    extension: "",
    launchRunCheck: "false",
    launchRunId: "",
    launchRunParam: null,
    mountAppFile: "false",
  },
};

export const QualifierOptions = [
  {
    label: "file/path",
    value: "file",
  },
  {
    label: "set/tuple",
    value: "set",
  },
  {
    label: "val",
    value: "val",
  },
  {
    label: "each",
    value: "each",
  },
  {
    label: "env",
    value: "env",
  },
];

export const OutputParameterOptions = [
  {
    label: "Data Tables",
    value: "table",
  },
  {
    label: "Data Tables Percentage",
    value: "table-percent",
  },
  {
    label: "HTML",
    value: "html",
  },
  {
    label: "Image",
    value: "image",
  },
  {
    label: "PDF Reader",
    value: "pdf",
  },
  {
    label: "Text",
    value: "text",
  },
  {
    label: "Apps",
    value: "apps",
  },
];

export enum ImportViaPipelineCategoryMapping {
  pipeline = "Pipeline",
  modules = "Pipeline Module",
  app = "Application",
  process = "Process",
  aiModel = "AI Model",
  modelSkill = "Model Skill",
}

export enum NODE_TYPE_PREFIX {
  Input = "inPro",
  Output = "outPro",
  Module = "p",
  Model = "m",
  Skill = "s",
}
